import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_ICON } from "@/data/brand";
import { resolvePhotoUrl } from "@/lib/photos";

const PODIUM = {
  0: { label: "1°", color: "#FFD700", shadow: "0 20px 50px -20px rgba(255,215,0,0.55)" },
  1: { label: "2°", color: "#C0C0C0", shadow: "0 20px 50px -20px rgba(192,192,192,0.45)" },
  2: { label: "3°", color: "#CD7F32", shadow: "0 20px 50px -20px rgba(205,127,50,0.45)" },
};

export default function TopClicked({ items }) {
  if (!items || items.length === 0) return null;
  const top3 = items.slice(0, 3);
  const rest = items.slice(3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-testid="top-clicked-section">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#E619A8] mb-2">· Top 10</div>
          <h2 className="font-heading font-black text-3xl md:text-5xl leading-tight">Annunci più <span className="text-[#FFBE00]">cliccati</span>.</h2>
        </div>
        <Link to="/annunci" className="text-sm text-zinc-400 hover:text-[#FFBE00] uppercase tracking-wider">Tutti →</Link>
      </div>

      {/* PODIUM */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5" data-testid="top-clicked-podium">
        {top3.map((l, i) => {
          const p = PODIUM[i];
          const icon = CATEGORY_ICON[l.category_slug] || "fa-briefcase";
          return (
            <Link
              key={l.id}
              to={`/annunci/${l.id}`}
              className="relative rounded-xl overflow-hidden border bg-[#0A0A0A] flex animate-fade-up hover:-translate-y-1 transition-transform"
              style={{ borderColor: p.color, boxShadow: p.shadow, animationDelay: `${i * 0.08}s` }}
              data-testid={`podium-${i + 1}`}
            >
              <div className="relative w-24 md:w-28 flex-shrink-0 bg-[#111]">
                {l.photos?.[0] ? (
                  <img src={resolvePhotoUrl(l.photos[0])} alt={l.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center"><i className={`fas ${icon} text-2xl text-zinc-700`}></i></div>
                )}
                <div className="absolute top-1 left-1 px-1.5 py-0.5 rounded text-[10px] font-black uppercase" style={{ background: p.color, color: "#000" }}>{p.label}</div>
              </div>
              <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-zinc-500 truncate flex items-center gap-1">
                    <i className={`fas ${icon}`} style={{ color: p.color }}></i>
                    <span>{l.category_name}</span>
                  </div>
                  <div className="font-heading font-bold text-sm mt-1 leading-tight line-clamp-2">{l.title}</div>
                </div>
                <div className="flex items-center justify-between text-xs mt-2">
                  <span className="flex items-center gap-1 font-bold" style={{ color: p.color }}>
                    <i className="fas fa-user"></i> {l.unique_views || 0} <span className="text-zinc-500 font-normal hidden sm:inline">visitatori</span>
                  </span>
                  <span className="text-zinc-500 hover:text-white transition-colors">Entra →</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      {/* COMPACT LIST 4..10 */}
      {rest.length > 0 && (
        <div className="hm-card p-2" data-testid="top-clicked-list">
          {rest.map((l, i) => {
            const rank = i + 4;
            const icon = CATEGORY_ICON[l.category_slug] || "fa-briefcase";
            return (
              <Link
                key={l.id}
                to={`/annunci/${l.id}`}
                className="group flex items-center gap-3 px-2 py-2 rounded-md hover:bg-[#141414] transition-colors"
                data-testid={`top-row-${rank}`}
              >
                <span className="w-6 text-center font-heading font-black text-sm text-zinc-600 group-hover:text-[#FFBE00]">{rank}</span>
                <div className="w-12 h-12 flex-shrink-0 rounded-md overflow-hidden bg-[#111] border border-zinc-800">
                  {l.photos?.[0] ? (
                    <img src={resolvePhotoUrl(l.photos[0])} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center"><i className={`fas ${icon} text-xs text-zinc-600`}></i></div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-bold truncate">{l.title}</div>
                  <div className="text-[11px] text-zinc-500 flex items-center gap-1"><i className={`fas ${icon} text-[#E619A8] text-[10px]`}></i>{l.category_name}</div>
                </div>
                <div className="text-xs font-bold text-[#FFBE00] whitespace-nowrap">
                  <i className="fas fa-user text-[10px] mr-1"></i>{l.unique_views || 0}
                </div>
                <span className="text-zinc-600 group-hover:text-white transition-colors text-xs whitespace-nowrap">→</span>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
